
import { _sendWithAxios } from './api'


export const cidadesBrasil = async (UF) => {
    return await _sendWithAxios(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${UF}/municipios?orderBy=nome`, 'GET')
      //                           https://servicodados.ibge.gov.br/api/v1/localidades/estados/{UF}/municipios
}

export const estados =
    ["AC",
        "AL",
        "AP",
        "AM",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RS",
        "RO",
        "RR",
        "SC",
        "SP",
        "SE",
        "TO"]